module.exports = __webpack_public_path__ + "img/banner_store_coop1_2.54dd2c0b.png";